import { AdvanceStageSelect } from "@forwardflow/modals/MapStageModal/AdvanceStageSelect";
import { SelectField } from "@forwardflow/ui";
import Icon from "@forwardflow/ui/Icons";
import { useState } from "react";

export const StopReviveStages = () => {
  const [edit, setEdit] = useState<boolean>(false);

  const [selectedStage, setSelectedStage] = useState<string>(
    "Default FUB updation"
  );
  return (
    <div className="flex justify-between px-10 py-5 bg-primary/10">
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-between w-full">
          <div className="flex items-center mt-3 font-medium text-white gap-x-4 mb-7">
            <Icon name="Nurture" />
            <span>Stop/Revive Stage</span>
          </div>
          <div>
            {!edit ? (
              <button
                onClick={() => setEdit(true)}
                className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
              >
                Edit
              </button>
            ) : (
              <div className="flex gap-x-4">
                <button
                  onClick={() => setEdit(true)}
                  className={`h-10 font-medium rounded bg-white/10 w-28 hover:bg-white/20 transition-all`}
                >
                  Reset
                </button>
                <button
                  onClick={() => setEdit(false)}
                  className={`h-10 font-medium rounded bg-primary hover:bg-primary-dark w-28 transition-all`}
                >
                  Done
                </button>
              </div>
            )}
          </div>
        </div>

        {edit && (
          <p className="border-b border-black/20 text-[12px] mb-7">
            <SelectField
              className="ff-inline-select-border-4 max-w-52"
              defaultValue={"Default FUB updation"}
              options={[
                {
                  label: "Default FUB updation",
                  value: "Default FUB updation",
                },
                {
                  label: "Organization default",
                  value: "Organization default",
                },
                {
                  label: "Advanced FUB matching",
                  value: "Advanced FUB matching",
                },
              ]}
              onChange={(value) => {
                setSelectedStage(value);
              }}
            ></SelectField>
          </p>
        )}
        <>
          {selectedStage === "Default FUB updation" ||
          selectedStage === "Organization default" ? (
            <>
              <p className="text-[14px] font-medium mb-4">{selectedStage}</p>
              <p className="text-[12px] text-[#D2D2D2] max-w-[584px] mb-6">
                Once a lead enters a stop or revive stage, we will move them all
                to a new stage in FUB called Forward Flow Stop
              </p>
            </>
          ) : (
            <>
              <div className="pb-3">
                <div className="flex items-center mb-4 gap-x-4">
                  <p className="text-[14px] text-white font-medium">
                    Advanced FUB matching
                  </p>
                </div>
                <p className="text-[12px] text-[#D2D2D2]">
                  Match stages fro your Follow Up Boss to Forward Flow Stop
                  stages
                </p>
                <div>
                  <div>
                    <div className="flex text-[#D2D2D2] gap-x-2 text-[12px] my-5">
                      <Icon name="Info" className="text-white" />
                      <span>
                        For the stages which we couldn’t find a match, we have
                        suggested you, new stages to be created in FUB. But you
                        can select another existing stage instead.
                      </span>
                    </div>
                    <div className="flex flex-col gap-y-1">
                      <div className="flex flex-col gap-y-1">
                        <AdvanceStageSelect
                          className="rounded-lg bg-white/5"
                          title="Do not Contact"
                        >
                          <Icon
                            name="Stop"
                            width={14}
                            height={14}
                            className="mr-1"
                          />
                        </AdvanceStageSelect>
                        <AdvanceStageSelect
                          className="rounded-lg bg-white/5"
                          title="Has another Agent"
                        >
                          <Icon name="User" className="scale-105" />
                        </AdvanceStageSelect>
                        <AdvanceStageSelect
                          className="rounded-lg bg-white/5"
                          title="Not Qualified"
                        >
                          <Icon
                            name="NotQualified"
                            width={14}
                            height={14}
                            className="mr-1"
                          />
                        </AdvanceStageSelect>
                        <AdvanceStageSelect
                          className="rounded-lg bg-white/5"
                          title="Credit Repair"
                        >
                          <Icon
                            name="Repair"
                            width={14}
                            height={14}
                            className="mr-1"
                          />
                        </AdvanceStageSelect>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </>
      </div>
    </div>
  );
};
